var _path, _mask, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLift = function SvgLift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 13a1 1 0 1 0 0 2v-2Zm12 2a1 1 0 1 0 0-2v2ZM2 15h12v-2H2v2ZM2 1a1 1 0 1 0 0 2V1Zm12 2a1 1 0 1 0 0-2v2ZM2 3h12V1H2v2ZM8 9a1 1 0 1 0 0 2V9Zm6 2a1 1 0 0 0 0-2v2Zm-6 0h6V9H8v2ZM8 5a1 1 0 1 0 0 2V5Zm6 2a1 1 0 0 0 0-2v2ZM8 7h6V5H8v2Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lift_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.457 3.172 3.429.686a.5.5 0 0 1 .821.384v4.991a.5.5 0 0 1-.822.382L.455 3.938a.5.5 0 0 1 .002-.766Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.207 7.618 2.972-2.486A.5.5 0 0 1 5 5.515v4.992a.5.5 0 0 1-.822.382L1.205 8.384a.5.5 0 0 1 .002-.766Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.43.686 1.282 1.535L3.43.686ZM.456 3.172-.826 1.638.457 3.172Zm-.002.766 1.29-1.529-1.29 1.53Zm2.973 2.505 1.289-1.529-1.29 1.53ZM2.146-.847-.826 1.637 1.74 4.707 4.712 2.22 2.146-.848Zm-2.98 6.315L2.14 7.973l2.578-3.059L1.744 2.41-.833 5.468Zm7.084.593V1.07h-4v4.991h4ZM2.139 7.973c1.626 1.37 4.111.214 4.111-1.912h-4c0-1.276 1.491-1.969 2.467-1.147L2.139 7.973ZM-.826 1.638a2.5 2.5 0 0 0-.007 3.83l2.577-3.059c.713.6.711 1.7-.004 2.298L-.826 1.638Zm5.538.583c-.976.816-2.462.122-2.462-1.151h4c0-2.122-2.476-3.279-4.104-1.918l2.566 3.069Z",
    mask: "url(#lift_svg__a)",
    transform: "translate(.75 4.445)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4.5 5.5 2 8l2.5 2.5"
  })));
};
export default SvgLift;